module.exports = __webpack_public_path__ + "static/media/structure_template.3a2042d1.xlsx";